import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-search-icon lucide-search", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m21 21-4.34-4.34" }), /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 11, r: 8 }));
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
